import React, {useState, useEffect} from 'react';

// components
import {BtnIcon} from 'components/btns';
import {Loading} from 'components/items';
import {InputText, InputSaveBtn, InputImage, InputDate, AdminForm} from 'admin/components';
import {alertDone, alertDelete} from 'function/alert';

// image
import ic_close from 'image/ic_close_b.svg';
import ic_write from 'image/ic_write.svg';
import ic_plus from 'image/icon/ic_plus_w.svg';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
import 'firebase/storage';
var db = firebase.firestore();
var fb_storage = firebase.storage();

// field
const FORMINIT = {
  title: "",
  imageName : "이미지 첨부",
  imageUrl: "",
  date: "",
  source: "",
  text: "",
  url: ""
}

const COLLECTION = "medias";
const dbRoot = (el) => {
  return `${COLLECTION}/${el.title}_${el.source}_${el.imageName}`;
}

const AboutMedia = () => {
  const [isFloating, setIsFloating] = useState(false);  
  const [isLoading, setIsLoading] = useState(false);
  const [nowForm, setNowForm] = useState(FORMINIT);
  const [imageFile, setImageFile] = useState(null);
  const [nowDbId, setNowDbId] = useState();
  const [medias, setMedias] = useState([]);

  // get data
  const _get = () => {
    setIsLoading(true);
    db.collection(COLLECTION).orderBy('date', 'desc').get()
    .then(querySnapshot => {
      let arr = [];
      let temp = null;
      querySnapshot.forEach(doc => {
        temp = doc.data();
        temp['id'] = doc.id;
        arr.push(temp);
      })
      setMedias(arr);
      setIsLoading(false);
    })
  }


  useEffect(()=> {
    _get();
  },[])

  // - handler -
  const handleFloatingClick = () => {
    setIsFloating(!isFloating);
    if(isFloating){
        setNowDbId(null);
        setNowForm(FORMINIT);
      
    }
  }
  const handleFileChange = (e) => {
    if(e.target.files&&e.target.files[0]){
      if(e.target.files[0].type !== 'image/png' && e.target.files[0].type !== 'image/jpeg'){
        alert('jpeg 또는 png 파일만 업로드 가능합니다. ')
        return 
      }
      const file = e.target.files[0];
      setImageFile(file);

      const fileName = e.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e) => {
        setNowForm({
          ...nowForm,
          imageUrl: e.target.result,
          imageName: fileName,

        });
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }
  const handleTextChange = (e) => {
    const {name, value} = e.target;
    setNowForm({
      ...nowForm,
      [name] : value
    })    
  }
  const handleDateChange = (e) => {
    const {name, value} = e.target;
    setNowForm({
      ...nowForm,
      [name] : value
    })
  }
  const handleFormSubmit = async (e) => {
    

    e.preventDefault();
    if(nowDbId){
      // when eidt
      setIsLoading(true);
      await updateItems();
      setIsLoading(false);
      alertDone();
    }else{
      if(checkForm()){
        setIsLoading(true);
        await uploadData();
        setIsLoading(false);
        alertDone();
      }else{
        alert('형식을 모두 채워주세요.')
      }
    }
  }
  
  const handleDeleteClick = (id) => {
    if(alertDelete()){

      medias.forEach(el => {
        if(el.id===id){
          if(el.rootPath){
            fbDeleteImage(el.rootPath);
          }
        }
      })
      fbDeleteDb(id);
    }
  }

  const handleEditClick = (id) => {
    setNowDbId(id);
    medias.forEach(m => {
      if(m.id === id){
        setNowForm({...m});
        setIsFloating(true);
      }
    })
  }

  // method
  const checkForm = () => {
    // check form filled
    let result = true;
    Object.keys(FORMINIT).forEach(key => {
      if(FORMINIT[key] === nowForm[key]){
        if(key !== 'timestamp'){
          result = false;
          return;
        }
      }
    })
    return result;
  }

  const uploadData = async () => {
    const imageUrl = await fbAddImage(dbRoot(nowForm));
    fbAddDb(imageUrl);
  }

  const uploadItemsState = (el) => {
    const newMedias = medias;
    newMedias.push(el);
  }

  const updateItems = async () => {
    if(imageFile){
      await editItemImageDb();
    }else{
      await editItemTextDb();
    }
  }

  const editItemTextDb = async () => {
    try{
      const ref = await db.collection(COLLECTION).doc(nowDbId);
      await ref.set({...nowForm});
      console.log("Document successfully written!");

      editItems(nowDbId, nowForm);
      setNowDbId(null);
      setIsFloating(false);
      setIsLoading(false);
      setNowForm(FORMINIT);
    }
    catch(error) {
      console.error("Error writing document: ", error);
    };
  }

  const editItemImageDb = async () => {
    const rootPath = dbRoot(nowForm);
    const prevRoot = nowForm.rootPath;

    fbDeleteImage(prevRoot);
    const imageUrl = await fbAddImage(rootPath);

    // root, imageUrl, data
    const ref =await db.collection(COLLECTION).doc(nowDbId);
    await ref.set({
      ...nowForm,
      imageUrl,
      rootPath
    })

    editItems(nowDbId, {
      ...nowForm,
      imageUrl,
      rootPath
    });
    setNowForm(FORMINIT);
    setIsFloating(false);
    setImageFile(null);
    setNowDbId(null);
    setIsLoading(false);
  }

  const editItems = (id, form) => {
    setMedias(medias.map(m => {
      if(m.id === id){
        return m = form;
      }else{
        return m
      }
    }))
  }

  // firebase
  const fbAddImage = async (root) => {
    const storageRef = fb_storage.ref(root);
    await storageRef.put(imageFile);
    return storageRef.getDownloadURL()
  }

  const fbAddDb = async (imageUrl) => {
    try  {
      const docRef = await db.collection(COLLECTION).add({
        ...nowForm,
        imageUrl,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        rootPath: dbRoot(nowForm)
      })
      uploadItemsState({
        ...nowForm,
        id: docRef.id,
        imageUrl,
        rootPath: dbRoot(nowForm),
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
      console.log("Document successfully written!");
      setNowForm(FORMINIT);
      setIsFloating(false);
      setIsLoading(false);
      setImageFile(null);
    } catch(e) {
      console.log(e)
    }
  }
  const fbDeleteImage = (root) => {
    var desertRef = fb_storage.ref().child(root);
    desertRef.delete().then(()=> {
      console.log('image file delete')
    }).catch(err => {
      console.log(err);
    })
  }
  const fbDeleteDb = async (id) => {
    try{
      await db.collection(COLLECTION).doc(id).delete();
      setNowForm(FORMINIT);
      setMedias(medias.filter(el=> {
        return el.id !== id
      }))
    }
    catch(e){
      console.log(e);
    }    
  }

  

  return (
    <section className="AboutMedia lnbSectionn">

      <div className={`${isLoading ? "" : "hide"} wrap-inner-loading`}>
        <Loading />
      </div>
      
      {/* floating add btn */}
      <BtnIcon className={`btn-floating admin ${isFloating ? `rotate` : ""}`}btn-add-member image = {ic_plus} onClick = {handleFloatingClick}/>

      {/* admin form */}
      <div className={`dim about-media-dim ${isFloating ? `active` : ""}`}></div>
      <AdminForm title="맴버 추가하기" onSubmit = {handleFormSubmit} className={isFloating ? 'active' : "?"} handleFloatingClick = {handleFloatingClick}>
        <InputImage label = "이미지" name = {`imageName`} fileName = {nowForm.imageName} url = {nowForm.imageUrl} onChange = {handleFileChange}/>
        <InputText label = {'제목'} name = {'title'} placeholder = {'제목'} value = {nowForm.title} onChange = {handleTextChange}/>
        <InputDate label = "날짜" name = {`date`} value = {nowForm.date} onChange = {handleDateChange}/>
        <InputText label = {'출처'} name = {'source'} placeholder = {'출처'} value = {nowForm.source} onChange = {handleTextChange}/>
        <InputText label = {'내용'} name = {'text'} placeholder = {'내용'} value = {nowForm.text} onChange = {handleTextChange}/>
        <InputText label = {'링크'} name = {`url`} placeholder = {'링크'} value = {nowForm.url} onChange = {handleTextChange}/>
        <InputSaveBtn text = "저장"/>
      </AdminForm>

      {/* text */}
      {!medias 
      ? ''
      : <ul>
          {medias.map(media => {
            return <AboutMediaList item = {media} key = {media.id} handleDeleteClick = {handleDeleteClick} handleEditClick = {handleEditClick}/>
          })}
        </ul>
      }




    </section>
  );
}

// list component of media
const AboutMediaList = (props) => {
  return (
    <li className="list-admin media">
      <div className="wrap-image">
        <img src={props.item.imageUrl} alt={props.item.name} className="media-image"/>
      </div>
      <div className="wrap-text">
        <p className="adminList-title">{props.item.title}</p>
        <ul className="wrap-info">
          <li className="info">
            <p className="info-header">날짜</p>
            <p className="info-contents media-date">{props.item.date}</p>
          </li>
          <li className="info">
            <p className="info-header">출처</p>
            <p className="info-contents media-text">{props.item.source}</p>
          </li>
          <li className="info">
            <p className="info-header">텍스트</p>
            <p className="info-contents media-text">{props.item.text}</p>
          </li>
          <li className="info">
            <p className="info-header">링크</p>
            <p className="info-contents media-url">{props.item.url}</p>
          </li>
        </ul>
      </div>

      <ul className="btn-wrap">
        <img src={ic_write} alt="edit" onClick = {() => {props.handleEditClick(props.item.id)}}/>
        <img src={ic_close} alt="delete" onClick = {() => {props.handleDeleteClick(props.item.id)}}/>
      </ul>
    </li>
    
  );
}

export default AboutMedia;